import firebase from "firebase";

const catalogues = /** @type {const} */ ({
    PUBLIC_UNIVERSITIES: "public_universities"
});

/**
 * @returns {Promise<Array<CatalogueDoc<any>>>}
 */
export async function fetchCatalogues() {
    let response = await firebase.firestore().collection("catalogues").get().catch(error => console.log(`Error al obtener catalogos: ${JSON.stringify(error)}`));
    
    let catalogues = response.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    return catalogues;
}

/**
 * @param {string} catalogueID 
 * @returns {Promise<CatalogueDoc<any>|null>}
 */
export async function fetchCatalogueById(catalogueID) {
    let catalogue = await firebase.firestore().collection("catalogues").doc(catalogueID).get().catch(error => console.log(`Error al obtener catalogo ${catalogueID}: ${JSON.stringify(error)}`));
    return catalogue.exists ? { id: catalogue.id, ...catalogue.data() } : null;
}

/**
 * @param {string} catalogueID 
 * @param {any} value 
 */
export async function addValueToCatalogue(catalogueID, value) {
    let catalogueRef = firebase.firestore().collection("catalogues").doc(catalogueID);
    await catalogueRef.update({
        values: firebase.firestore.FieldValue.arrayUnion(value)
    }).catch(error => console.log(`Error al agregar valor al catalogo ${catalogueID}: ${JSON.stringify(error)}`));
}

export async function fetchPublicUniversitiesCatalogue() {
    let catalogue = await fetchCatalogueById(catalogues.PUBLIC_UNIVERSITIES);
    return /** @type {PublicUniversitiesCatalogueDoc} */ (catalogue);
}

/**
 * @param {string} value 
 */
export async function addValueToPublicUniversitiesCatalogue(value) {
    return await addValueToCatalogue(catalogues.PUBLIC_UNIVERSITIES, value);
}

/**
 * @template {any} T
 * @typedef {object} CatalogueDoc
 * @property {string} id
 * @property {string} description
 * @property {Array<T>} values
 */

/**
 * @typedef {object} PublicUniversitiesCatalogueDoc
 * @property {string} id
 * @property {string} description
 * @property {Array<string>} values
 */